import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { Controller, useFormContext } from "react-hook-form";
import Button from "@material-ui/core/Button";
import {locations} from "../../../assets/constants";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

export default function PersonalDetails(props) {
  const {
    control,
    formState: { errors },
    getValues,
    setError,
    clearErrors,
  } = useFormContext();
 

  return (
    <>
      <h5 className="fw-bold mb-3">Details about you</h5>
      <Grid container justify="center" spacing={3}>
        <Grid item xs={12} sm={6}>
          <Controller
            style={{ width: "100%" }}
            name="username"
            control={control}
            render={({ field }) => (
              <TextField
                required
                className="fw-bold mb-3"
                id="username"
                {...field}
                name="username"
                label="Username"
                fullWidth
                autoComplete="given-name"
                helperText={errors.username ? errors.username.message : ""}
                error={errors.username}
              />
            )}
          />
          {/* <Button onClick={() => checkUserName()}>Check username</Button> */}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            style={{ width: "100%" }}
            name="email"
            control={control}
            render={({ field }) => (
              <TextField
                required
                className="fw-bold mb-3"
                id="email"
                {...field}
                name="email"
                label="Email"
                type="email"
                fullWidth
                autoComplete="given-name"
                helperText={errors.email ? errors.email.message : ""}
                error={errors.email}
              />
            )}
          />
          {/* <Button onClick={() => checkUserName()}>Check username</Button> */}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            style={{ width: "100%" }}
            name="password"
            control={control}
            render={({ field }) => (
              <TextField
                required
                className="fw-bold mb-3"
                id="password"
                {...field}
                name="password"
                type="password"
                password
                label="Password"
                fullWidth
                helperText={errors.password ? errors.password.message : ""}
                error={errors.password}
              />
            )}
          />
          {/* <Button onClick={() => checkUserName()}>Check username</Button> */}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            style={{ width: "100%" }}
            name="passwordConfirmation"
            control={control}
            render={({ field }) => (
              <TextField
                required
                className="fw-bold mb-3"
                id="passwordConfirmation"
                {...field}
                name="passwordConfirmation"
                label="Confirm Password"
                fullWidth
                type="password"
                helperText={
                  errors.passwordConfirmation
                    ? errors.passwordConfirmation.message
                    : ""
                }
                error={errors.passwordConfirmation}
              />
            )}
          />
          {/* <Button onClick={() => checkUserName()}>Check username</Button> */}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="firstName"
            control={control}
            render={({ field }) => (
              <TextField
                required
                className="fw-bold mb-3"
                id="firstName"
                {...field}
                name="firstName"
                label="First name"
                fullWidth
                autoComplete="given-name"
                helperText={errors.firstName ? "First name is required" : ""}
                error={errors.firstName}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="lastName"
            control={control}
            render={({ field }) => (
              <TextField
                required
                className="fw-bold mb-3"
                id="lastName"
                name="lastName"
                label="Last name"
                fullWidth
                autoComplete="family-name"
                {...field}
                helperText={errors.lastName ? "Last name is required" : ""}
                error={errors.lastName}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            control={control}
            className="fw-bold mb-3"
            name="location"
            defaultValue={[]}
            render={({ field: { onChange, onBlur, value } }) => (
              <TextField
                select
                id="location"
                label="Location"
                fullWidth
                helperText={errors.location ? "Send us your Location" : ""}
                error={errors.location}
                SelectProps={{
                  multiple: false,
                  value: value,
                  renderValue: (selected) => selected,
                  onChange: onChange,
                }}
              >
                {locations
                    .sort()
                    .map((n) => (
                  <MenuItem key={n} value={n}>
                    <ListItemText primary={n} />
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="gender"
            control={control}
            render={({ field }) => (
              <FormControl style={{ width: "100%" }}>
                <TextField
                  className="fw-bold mb-3"
                  id="select"
                  label="Gender"
                  select
                  required
                  {...field}
                  helperText={errors.gender ? "Gender is required" : ""}
                  error={errors.gender}
                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                </TextField>
              </FormControl>
            )}
          />
        </Grid>
      </Grid>
    </>
  );
}
